import React, { FC } from 'react';
import Row from 'components/UI/Row';
import { Column } from 'components/UI/Column';
import {
  CloseButton,
  CloseInput,
  ModalContent,
  ModalHeader,
  ModalOverflow,
  ModalTitle,
  ModalHeaderBody,
  ModalHeaderTitle,
  ModalHeaderWrapper,
} from './SizeGuide.css';
import { useCategoryWithSizes } from '../Filters/useCategory';
import SizeGuideByDepartment from './SizeGuideByDepartment/SizeGuideByDepartment';
import { Desktop, Mobile } from '../MediaQuery';
import { HorizontalDivider } from '../../components_mobile/components/HorizontalDivider/HorizontalDivider';
import SizeGuideHeader from './SizeGuideHeader';
import { useUrlBuilder } from '../../hooks/useUrlBuilder';
import { ModalMobile } from './mobile/ModalMobile';

export const SizeGuide: FC<{
  closeSizeGuide: () => void;
  currentCategoryId: string;
  department: string;
  isOpen: boolean;
}> = ({ department, currentCategoryId, closeSizeGuide, isOpen }) => {
  const { withCDN } = useUrlBuilder();
  const { defaultSizeTab } = useCategoryWithSizes({ categoryId: currentCategoryId });

  const renderCommon = () => {
    const tabs = defaultSizeTab;
    const [defaultTab] = tabs;
    return <SizeGuideByDepartment defaultTab={defaultTab} department={department} />;
  };

  const renderMobileHeader = () => {
    return (
      <div>
        <ModalHeaderWrapper>
          <Row justifyContent="space-between">
            <Column>
              <ModalHeaderTitle>
                <SizeGuideHeader department={department} />
              </ModalHeaderTitle>
            </Column>
            <Column style={{ textAlign: 'right' }}>
              <CloseInput
                onClick={() => {
                  closeSizeGuide();
                }}
                src={withCDN('mkt/icon/x_black.png')}
                type="image"
              />
            </Column>
          </Row>
          <ModalHeaderBody>
            Please note that this is a representative guide only. Sizes and measurements may vary depending on the style
            of the item and how the brand fits. If you are not sure about a size or a fit, we recommend to try the
            product at a nearby luxury boutique.
          </ModalHeaderBody>
        </ModalHeaderWrapper>
        <HorizontalDivider padding="0 5%" />
      </div>
    );
  };

  return (
    <>
      <Mobile>
        {isOpen && (
          <ModalMobile
            ariaTitle="Size guide"
            closeModal={closeSizeGuide}
            isOpen={isOpen}
            mainContent={renderCommon()}
            stickyHeader={{
              node: renderMobileHeader(),
            }}
          />
        )}
      </Mobile>

      <Desktop>
        {isOpen && (
          <>
            <ModalContent>
              <ModalHeader>
                <ModalTitle>
                  <SizeGuideHeader department={department} />
                </ModalTitle>
                <CloseButton
                  onClick={() => {
                    closeSizeGuide();
                  }}
                >
                  x
                </CloseButton>
              </ModalHeader>
              {renderCommon()}
            </ModalContent>
            <ModalOverflow
              onClick={() => {
                closeSizeGuide();
              }}
            />
          </>
        )}
      </Desktop>
    </>
  );
};
